import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private readonly router = inject(Router);

  private isShown = new BehaviorSubject(true);

  constructor() {
    // When we load a new route, show the footer by default
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isShown.next(true);
      }
    });
  }

  getVisibility(): Observable<boolean> {
    return this.isShown.asObservable();
  }

  setVisibility(isFooterVisible: boolean): void {
    this.isShown.next(isFooterVisible);
  }
}
